import { Avatar, Card, Divider, Image, List, Space, Table } from 'antd';
import React, { useMemo } from 'react';
import ContainerComponent from '../../../helpers/components/container.component';
import numberHelper from '../../../helpers/functions/number.helper';

const TicketDetail = ({ ticket, }) => {
    const park = useMemo(() => ticket?.park, [ticket]);
    // const ticket_users = useMemo(() => ticket?.ticket_users, [ticket]);
    // const add_ons = useMemo(() => ticket?.add_ons, [ticket]);

    const item_list = useMemo(() => {
        const { ticket_users, add_ons, } = ticket ?? {};
        const mapped_ticket_users = ticket_users?.map((ticket_user, index) => {
            const { ticket_user_type, count, tax_amount, price, } = ticket_user;
            return {
                name : ticket_user_type?.name,
                count : count,
                tax_amount : tax_amount,
                price : price,
            }
        }) ?? []

        const mapped_add_ons = add_ons?.map((add_ons, index) => {
            const { name, TicketAddOn, } = add_ons;
            return {
                name,
                count : TicketAddOn?.quantity,
                tax_amount : TicketAddOn?.tax_amount,
                price : TicketAddOn?.price,
            }
        }) ?? []

        return [...mapped_ticket_users, ...mapped_add_ons];
    }, [ticket])

    return (
        <>
            <ContainerComponent top={20} span={18}>
                <Space size={24} style={{ width : '100%', }} direction='vertical'>
                    {/* Summary */}
                    <Card
                    // className='card-shadow'
                    styles={{ body : { padding : 0, } }}
                    style={{border:'1.5px solid #cbd5e0', color : 'var(--secondary-text-color)',}}
                    >
                        <div style={{ textAlign : 'start', padding : 24, }}>
                            <SubResultItem
                            title={"Amount"}
                            value={(
                                <>
                                    <span style={{ fontWeight : 500, fontSize : 26, lineHeight : 1, }}>{park?.currency?.code} {numberHelper?.commaNumber(ticket?.payment_amount)}</span>
                                </>
                            )}
                            />
                            
                            <div style={{ marginTop : 12, }}>
                                <Space direction='vertical' style={{ width : '100%', }}>
                                    <SubResultItem title={"Transaction Number"} value={ticket?.running_number} />
                                    <SubResultItem title={"Ticket Type"} value={ticket?.ticket_type?.name} />
                                    <SubResultItem title={"Visit Date"} value={ticket?.visit_date} />
                                </Space>
                            </div>
                        </div>

                        <Divider style={{ margin : 0, }} />

                        <div style={{ textAlign : 'start', padding : 24, paddingTop : 12, }}>
                            <List
                            dataSource={item_list}
                            split={false}
                            // size='small'
                            renderItem={(item, index) => {
                                const { count, name, tax_amount, price, } = item ?? {};
                                return (
                                    <List.Item key={index} style={{ paddingInline : 0, }}>
                                        <div style={{ display : 'flex', flexWrap : 'wrap', width : '100%', }}>
                                            <div>
                                                <div>
                                                    <span>{name}</span>
                                                </div>
                                                <div style={{ lineHeight : 1, }}>
                                                    <span style={{ fontSize : 12, color : 'var(--secondary-text-color)', }}>Qty {count}</span>
                                                </div>
                                            </div>

                                            <div style={{ marginLeft : 'auto', textAlign : 'right', }}>
                                                <div>
                                                    <span>{park?.currency?.code} {numberHelper?.commaNumber(price * count)}</span>
                                                </div>
                                                <div style={{ lineHeight : 1, }}>
                                                    <span style={{ fontSize : 12, color : 'var(--secondary-text-color)', }}>{park?.currency?.code} {numberHelper?.commaNumber(price)} each</span>
                                                </div>
                                            </div>
                                        </div>
                                    </List.Item>
                                )
                            }}
                            />
                        </div>
                    </Card>
                    
                    

                    {/* Purchased Item */}
                    <div>
                        
                    </div>
                </Space>
            </ContainerComponent>
        </>
    );
}

const SubResultItem = ({ value, title, }) => {
    return (
        <>
            <div>
                <div>
                    <span style={{color:'#595959', fontWeight:500}}>{title}</span>
                </div>
                <div>
                    <span>{value}</span>
                </div>
            </div>
        </>
    );
}

export default TicketDetail;